const fv = document.querySelector('.p-top__fv');

if (fv) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      document.body.classList.toggle('is-fv-visible', entry.isIntersecting);
    },
    { threshold: 0.1 }
  );
  observer.observe(fv);
}
